import React, { useState, useEffect } from 'react';
import { Modal, Radio, Space, Typography } from 'antd';
import type { TeamPickCandidate } from '../services/tenantLogin';

const { Text } = Typography;

export type TeamPickModalProps = {
  open: boolean;
  title?: string;
  description?: string;
  candidates: TeamPickCandidate[];
  confirmLoading?: boolean;
  onCancel: () => void;
  onConfirm: (userId: string) => void;
};

const labelFor = (c: TeamPickCandidate) => {
  const sub =
    c.teamCode && c.teamName !== c.teamCode
      ? `${c.teamName}（${c.teamCode}）`
      : c.teamName || '未命名团队';
  const who = c.username && c.username !== sub ? ` · 账号 ${c.username}` : '';
  return `${sub}${who}`;
};

const TeamPickModal: React.FC<TeamPickModalProps> = ({
  open,
  title = '选择要进入的团队',
  description = '检测到您的登录信息在多个实验室中存在，请选择本次要进入的环境。',
  candidates,
  confirmLoading,
  onCancel,
  onConfirm
}) => {
  const [picked, setPicked] = useState<string>(() => candidates[0]?.userId || '');

  useEffect(() => {
    if (open && candidates.length) {
      setPicked(candidates[0].userId);
    }
  }, [open, candidates]);

  return (
    <Modal
      open={open}
      title={title}
      onOk={() => picked && onConfirm(picked)}
      onCancel={onCancel}
      okText="继续登录"
      cancelText="返回"
      confirmLoading={confirmLoading}
      destroyOnHidden
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Text type="secondary">{description}</Text>
        <Radio.Group value={picked} onChange={e => setPicked(e.target.value)} style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {candidates.map(c => (
              <Radio key={c.userId} value={c.userId} style={{ alignItems: 'flex-start' }}>
                {labelFor(c)}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Space>
    </Modal>
  );
};

export default TeamPickModal;
